import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaSegment'

type IcaSegmentProps = React.JSX.IntrinsicElements['tgdb-ica-segment']

export const IcaSegment = wrapWc<IcaSegmentProps>('tgdb-ica-segment', [])